export default __webpack_public_path__ + "static/media/8990_bp.955003c6.svg";